import { isEmpty, map, slice } from 'lodash'
import moment from 'moment'
import LOGIN_TO_PATIENT from '@/plugins/http/patient.js'

// slice for times
const addTimes = (dates, date, time) => {
  if (isEmpty(dates[date])) {
    dates[date] = []
  }

  dates[date] = time.toString().split(';')
}

// Parse date for format dd/mm
const parsedDay = (date) => {
  return moment(date).format('DD/MM')
}

export default {
  doSearchSchedules (agenda) {
    this.mbloading = true
    this.showTotal = false
    this.$http.get('v1/scheduling/see/availables/' + agenda.id)
      .then(({data}) => {
        this.schedules = data
        this.mbloading = false
        this.show = true
      })
      .catch((error) => {
        this.mbloading = false
        this.showTotal = true
        this.afterFailure(error)
      })
  },
  parsedDayDate (day) {
    return moment(day).format('DD/MM')
  },
  parseTimeDate (time) {
    return time.slice(0, 5)
  },
  doLoad () {
    const dates = {}
    map(this.agenda.items, (item) => {
      const date = moment(item.date).format('YYYY-MM-DD')
      addTimes(dates, date, item.times)
    })
    const keys = Object.keys(dates)
    const schedules = map(keys, (key) => {
      const times = dates[key]
      const schedule = {
        date: parsedDay(key),
        dateComplete: key,
        times,
        showTimes: slice(times, 0, 3)
      }
      return schedule
    })

    this.schedules = slice(schedules, 0, 4)
  },
  toPreSchedule (schedule, i) {
    // estanciando moment
    let now = moment().format('YYYY-MM-DD HH:mm:ss')
    // Id agendamentos
    const scheduleId = schedule.schedulings_id.split(';')
    // Horarios do agendamento
    const scheduleTime = schedule.times.split(';')
    this.saveLocalStoragePreSChedules(scheduleId[i], scheduleTime[i], now)

    // Alerta para informar que nao esta mais disponível este horario
    // precisar implementar aqui a reserva com a API
    // this.show = true

    // Direcioanando para uma url
    // window.location.href = 'http://app-v1.medibook.com.br/app/auth/login'
    window.location.href = LOGIN_TO_PATIENT + '?&ps=' + scheduleId[i]
  },
  saveLocalStoragePreSChedules (scheduleId, scheduledTime, now) {
    const pre = {id: scheduleId, time: scheduledTime, until: now}
    localStorage.setItem('preSchedule', JSON.stringify(pre))
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/profile-professional/components/schedule/resources/methods.js